import { WebClient } from '../../webclient/webclient.service';
export interface Product { id: number, image: string, name: string, description: string, details_url: string };


export class Products {

    public static list: Array<Product>;
    public static formAssinstantList: Array<Product>;

    public static getProducts(): Promise<Array<Product>> {

        return new Promise<Array<Product>>((resolve) => {
            if (Products.list) {
                resolve(Products.list);
            }
            else {
                WebClient.getProducts().then(data => {
                    Products.list = data.map(prod => { return { ...prod, displayName: prod.name, value: prod.id } })
                        .sort((a, b) => a.displayName.localeCompare(b.displayName));
                    resolve(Products.list);
                });
            }
        })
    }


    public static getProductsFormAssistant(): Promise<Array<Product>> {

        return new Promise<Array<Product>>((resolve) => {
            if (Products.formAssinstantList) {
                resolve(Products.formAssinstantList);
            }
            else {
                WebClient.getProductsFormAssistant().then(data => {
                    Products.formAssinstantList = data.map(prod => { return { ...prod, displayName: prod.name, value: prod.id } })
                        .sort((a, b) => a.displayName.localeCompare(b.displayName));
                    resolve(Products.formAssinstantList);
                });
            }
        })
    }
}